module.exports = __webpack_public_path__ + "img/文字_B级赛事@2x.ce854735.png";